import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPages,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal, selectOptionsAsap,
  selectOptionsPlus
} from '../project/projectSelectros';

export const selectBanners = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.banners || {}
);

export const selectBannersCalculationParams = createSelector(
  selectBanners,
  projectOther => projectOther.calculationOptions || {}
);

export const selectBannersNumberOfPages = createSelector(
    selectOptionsPages,
    ( options) => {
        let pricesRepeated = [];
        for (let i = 0; i < options.length; i++) {
            const priceValue = options[i].priceValue;
            const priceQuantity = options[i].quantityValue;
            const prices = Array(priceQuantity).fill(priceValue);
            pricesRepeated = [...pricesRepeated, ...prices];
        }
        const numberOfPages = pricesRepeated.length;

        return {
            totalNumberOfPages: numberOfPages
        };
    }
);
export const selectBannersNumberOfStaticPages = createSelector(
    selectOptionsPages,
    ( options) => {
        let pricesLength = 0;
        for (let i = 0; i < options.length; i++) {
            if (options[i].title === 'Static') {
                const priceValue = options[i].priceValue;
                const priceQuantity = options[i].quantityValue;
                const prices = Array(priceQuantity).fill(priceValue);
                pricesLength = prices.length;
            }
        }
        const numberOfPages = pricesLength;
        return {
            totalNumberOfStaticPages: numberOfPages
        };
    }
);

export const selectBannersOptionsPlusTypesTotal = createSelector(
    selectBannersCalculationParams,
    selectOptionsPlus,
    selectBannersNumberOfPages,
    selectBannersNumberOfStaticPages,
    ({discountPercentForMoreFive}, plusOptions, {  totalNumberOfPages}, {  totalNumberOfStaticPages } ) => {

        var plusOptionsForEveryPage = [];
        var plusOptionsSingle = [];

        for (let i = 0; i < plusOptions.length; i++) {
            if (plusOptions[i].isForEveryPage) {
                plusOptionsForEveryPage = [...plusOptionsForEveryPage, plusOptions[i]];
            } else {
                plusOptionsSingle = [...plusOptionsSingle, plusOptions[i]];

            }
        }

        /* for banners plusOptionsForEveryPageTotal - is about animation options, and it is not for Static Banner*/
        var plusOptionsForEveryPageTotal = plusOptionsForEveryPage.reduce((accumulator, currentValue) => accumulator + currentValue.priceValue, 0);
        var plusOptionsSingleTotal = plusOptionsSingle.reduce((accumulator, currentValue) => accumulator + currentValue.priceValue, 0);

        //discount 50% from 6th page begin
        var pricePlusOptionsTotal;
        var discountPlusOptionsTotal = 0;

        if (totalNumberOfPages >= 6) {
            var numberOptionsWithDiscount = totalNumberOfPages - 5;
            if (totalNumberOfStaticPages === 0 ) {
                numberOptionsWithDiscount = totalNumberOfPages - 5;
                pricePlusOptionsTotal = (plusOptionsForEveryPageTotal * 5) + (plusOptionsForEveryPageTotal * (discountPercentForMoreFive / 100) * numberOptionsWithDiscount);
                discountPlusOptionsTotal = plusOptionsForEveryPageTotal * totalNumberOfPages - pricePlusOptionsTotal;
            } else if ((totalNumberOfPages - totalNumberOfStaticPages) <=5 )  {
                numberOptionsWithDiscount = 0;
                pricePlusOptionsTotal = (plusOptionsForEveryPageTotal * (totalNumberOfPages - totalNumberOfStaticPages)) + (plusOptionsForEveryPageTotal * (discountPercentForMoreFive / 100) * numberOptionsWithDiscount);
                discountPlusOptionsTotal = plusOptionsForEveryPageTotal * (totalNumberOfPages - totalNumberOfStaticPages) - pricePlusOptionsTotal;
            }else if (totalNumberOfPages - totalNumberOfStaticPages > 5 )  {
                numberOptionsWithDiscount = totalNumberOfPages - totalNumberOfStaticPages - 5;
                pricePlusOptionsTotal = (plusOptionsForEveryPageTotal * 5) + (plusOptionsForEveryPageTotal * (discountPercentForMoreFive / 100) * numberOptionsWithDiscount);
                discountPlusOptionsTotal = plusOptionsForEveryPageTotal * (totalNumberOfPages - totalNumberOfStaticPages) - pricePlusOptionsTotal;
            }

        } else {
            // pricePlusOptionsTotal = plusOptionsForEveryPageTotal * totalNumberOfPages;
            pricePlusOptionsTotal = plusOptionsForEveryPageTotal * (totalNumberOfPages - totalNumberOfStaticPages);
        }

        pricePlusOptionsTotal += plusOptionsSingleTotal;
        //discount 50% from 6th page end

        return {
            totalPricePlusOptions: pricePlusOptionsTotal,
            totalDiscountPlusOptions: discountPlusOptionsTotal
        };
    }
);


export const selectBannersPagesTotal = createSelector(
  selectBannersCalculationParams,
  selectOptionsPages,
  selectBannersOptionsPlusTypesTotal,
  ({discountPercentForMoreFive}, options, {totalDiscountPlusOptions}) => {
    let pricesRepeated = [];
    for (let i = 0; i < options.length; i++) {
      const priceValue = options[i].priceValue;
      const priceQuantity = options[i].quantityValue;
      const prices = Array(priceQuantity).fill(priceValue);
      pricesRepeated = [...pricesRepeated, ...prices];
    }
    const pricesRepeatedReverse = pricesRepeated.reverse();
    const pricesFirstFive = pricesRepeatedReverse.slice(0, 5);
    const pricesFirstFiveTotal = pricesFirstFive.reduce((a, b) => a + b, 0);
    const pricesRest = pricesRepeatedReverse.slice(5);
    const pricesRestTotal = pricesRest.reduce((a, b) => a + b, 0);
    const priceDiscount = Math.ceil(pricesRestTotal * (discountPercentForMoreFive / 100)) + totalDiscountPlusOptions;
    const priceTotal = pricesFirstFiveTotal + pricesRestTotal - (priceDiscount - totalDiscountPlusOptions);

    return {
      discount: priceDiscount,
      totalPricePages: priceTotal
    };
  }
);

export const selectBannersOptionsTotal = createSelector(
  selectBannersPagesTotal,
  selectBannersOptionsPlusTypesTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, {totalPricePlusOptions}, totalPricePercentOptions) => {
    const totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + (totalPricePages ? totalPricePlusOptions : 0);
  }
);

export const selectBannersTotal = createSelector(
  selectBannersPagesTotal,
  selectBannersOptionsTotal,
  selectOptionsAsap,
  ({totalPricePages}, totalPriceOptions, asap) => {
    const  isASAP = asap.length;
    return isASAP ? (totalPricePages + totalPriceOptions) * 2 : totalPricePages + totalPriceOptions;
  }
);

export const selectBannersTotalForAsap = createSelector(
  selectBannersTotal,
  (totalPrice) => {
      return totalPrice / 2;
  }
);

export const selectBannersEta = createSelector(
  selectBannersCalculationParams,
  selectBannersTotal,
    selectOptionsPages,
    selectOptionsAsap,
  ({dayWorkHours, pricePerHour}, totalPrice, options, asap) => {
    const  isASAP = asap.length;
    var pagesStaticCount = 0;
    var pagesSimpleCount = 0;
    var pagesComplexCount = 0;
    var pagesInteractiveCount = 0;


    for (let i = 0; i < options.length; i++) {
        if (options[i].titleForETA === 'static') {
            pagesStaticCount = options[i].totalQuantity;
        } else if (options[i].titleForETA === 'simple') {
            pagesSimpleCount = options[i].totalQuantity;
        } else if (options[i].titleForETA === 'complex'){
            pagesComplexCount = options[i].totalQuantity;
        } else if (options[i].titleForETA === 'interactive'){
            pagesInteractiveCount = options[i].totalQuantity;
        }
    }

    var etaStatic = 0;
    var etaSimple = 0;
    var etaComplex = 0;
    var etaInteractive = 0;

    etaStatic = Math.ceil(pagesStaticCount / 9);
    etaSimple = Math.ceil(pagesSimpleCount / 5);
    etaComplex = Math.ceil(pagesComplexCount / 5);

      if (pagesInteractiveCount === 1) {
          etaInteractive = 1;
      } else if (pagesInteractiveCount === 2) {
          etaInteractive = 2;
      } else if (pagesInteractiveCount > 2 && pagesInteractiveCount <= 5) {
          etaInteractive = 3;
      } else if (pagesInteractiveCount > 5 && pagesInteractiveCount <= 9) {
          etaInteractive = 5;
      } else if (pagesInteractiveCount > 9) {
          etaInteractive = Math.ceil(((pagesInteractiveCount - 9) / 4) + 5);
      }


    const eta = etaStatic + etaSimple + etaComplex + etaInteractive;
    const etaIsExists = !!eta;
    const etaTextCommon = `${eta} business day${eta > 1 ? 's' : ''}`;
    const etaTextAsap = `custom (turbo mode on)`;
    const etaText = isASAP ? etaTextAsap : etaTextCommon;

    return {
      etaText,
      etaIsExists
    };
  }
);

export const selectBannersDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});

